(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(cents / 100); }
    catch(e) { return `$${(cents / 100).toFixed(2)}`; }
  };

  const shell = $('[data-cart-shell]');
  const openCart = () => { if (!shell) return; shell.hidden = false; document.body.style.overflow = 'hidden'; refreshCart(); };
  const closeCart = () => { if (!shell) return; shell.hidden = true; document.body.style.overflow = ''; };
  $$('[data-cart-open]').forEach(el => el.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));

  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const total = $('[data-cart-total]'); if (total) total.textContent = money(cart.total_price);
    const items = $('[data-cart-items]');
    if (items) items.innerHTML = cart.items.length ? cart.items.map(item => `
      <div class="drawer-line" data-line-key="${item.key}">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g,'&quot;')}">` : ''}
        <div><a href="${item.url}"><strong>${item.product_title}</strong></a><p class="muted">${item.variant_title || ''}</p><p>${money(item.final_line_price)}</p><div class="qty-controls"><button type="button" data-qty-change="-1" data-key="${item.key}">−</button><span>${item.quantity}</span><button type="button" data-qty-change="1" data-key="${item.key}">+</button></div></div>
      </div>`).join('') : '<p class="muted">YOUR BAG IS EMPTY.</p>';
    const progress = $('[data-shipping-progress]');
    if (progress) {
      const threshold = window.GOC_THEME?.freeShippingThreshold || 0;
      if (!threshold) progress.innerHTML = '';
      else {
        const remaining = Math.max(0, threshold - cart.total_price);
        const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        progress.innerHTML = remaining > 0 ? `YOU’RE ${money(remaining)} AWAY FROM FREE SHIPPING<div class="shipping-meter"><span style="width:${pct}%"></span></div>` : `YOU UNLOCKED FREE SHIPPING ✓<div class="shipping-meter"><span style="width:100%"></span></div>`;
      }
    }
    bindQty();
  };
  const refreshCart = () => fetch('/cart.js').then(r => r.json()).then(renderCart);
  const bindQty = () => $$('[data-qty-change]').forEach(btn => btn.onclick = async () => {
    const cart = await fetch('/cart.js').then(r => r.json());
    const line = cart.items.find(x => x.key === btn.dataset.key); if (!line) return;
    const quantity = Math.max(0, line.quantity + Number(btn.dataset.qtyChange));
    const updated = await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ id: btn.dataset.key, quantity }) }).then(r=>r.json());
    renderCart(updated);
  });
  bindQty();

  $$('form[data-ajax-cart]').forEach(form => form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const button = $('[data-add-button]', form); if (button) button.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method:'POST', headers:{ 'Accept':'application/json' }, body:new FormData(form) });
      if (!res.ok) throw new Error('Unable to add item');
      await refreshCart(); openCart();
    } catch (err) { alert(err.message); }
    finally { if (button) button.disabled = false; }
  }));

  $$('[data-product-root]').forEach(root => {
    const json = $('[data-product-variants]', root);
    const variants = json ? JSON.parse(json.textContent) : [];
    const optionGroups = $$('[data-option-index]', root);
    const idInput = $('[data-variant-id]', root);
    const add = $('[data-add-button]', root);
    const addLabel = $('[data-add-label]', root);
    const addPrice = $('[data-add-price]', root);
    const price = $('[data-product-price]', root);
    const stickyPrice = $('[data-sticky-price]', root);
    const stickyBtn = $('[data-sticky-add]', root);
    const selections = optionGroups.map(group => $('.variant-button.is-selected', group)?.dataset.optionValue || $('.variant-button', group)?.dataset.optionValue);

    const updateVariant = () => {
      if (!variants.length) return;
      const variant = variants.find(v => v.options.every((opt, i) => opt === selections[i]));
      if (!variant) return;
      idInput.value = variant.id;
      const display = money(variant.price);
      if (price) price.textContent = display; if (addPrice) addPrice.textContent = display; if (stickyPrice) stickyPrice.textContent = display;
      if (add) add.disabled = !variant.available; if (stickyBtn) stickyBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    };
    optionGroups.forEach((group, i) => $$('.variant-button', group).forEach(btn => btn.addEventListener('click', () => {
      $$('.variant-button', group).forEach(b => b.classList.remove('is-selected')); btn.classList.add('is-selected'); selections[i] = btn.dataset.optionValue; const label = $('[data-option-label]', group); if (label) label.textContent = selections[i]; updateVariant();
    })));
    if (stickyBtn) stickyBtn.addEventListener('click', () => add?.click());
  });

  const menuBtn = $('[data-mobile-menu-toggle]'), menu = $('[data-mobile-menu]');
  if (menuBtn && menu) menuBtn.addEventListener('click', () => { menu.hidden = !menu.hidden; menuBtn.textContent = menu.hidden ? '☰' : '×'; });

  $$('[data-sort-by]').forEach(select => select.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', select.value); location.href = u.toString(); }));

  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() { if (this.innerHTML.trim()) return; const url = this.dataset.url; if (!url) return; fetch(url).then(r=>r.text()).then(text => { const doc = new DOMParser().parseFromString(text,'text/html'); const incoming = doc.querySelector('product-recommendations'); if (incoming && incoming.innerHTML.trim()) this.innerHTML = incoming.innerHTML; }).catch(()=>{}); }
  });
})();
